import { render, staticRenderFns } from "./InputSubstitudeHolidayModal.vue?vue&type=template&id=0c26e002"
import script from "./InputSubstitudeHolidayModal.vue?vue&type=script&lang=js"
export * from "./InputSubstitudeHolidayModal.vue?vue&type=script&lang=js"
import style0 from "./InputSubstitudeHolidayModal.vue?vue&type=style&index=0&id=0c26e002&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports